<template lang='pug'>
td.tableTop10-main
  .tableTop10-contentLeft.text--left
    .tableTop10-image(v-if="info.thumbnailUrl" :style='"background-image: url(" + info.thumbnailUrl + "),url(" + info.category.thumbnailUrl + ");"')
    .tableTop10-image(v-else-if="info.category && info.category.thumbnailUrl" :style='"background-image: url(" + info.category.thumbnailUrl + ");"')
    .tableTop10-image(v-else :style="defaultImage")
  .tableTop10-contentRight
    .tableTop10-mainTop
      .tableTop10-text.heading-cardTitle
        v-clamp.ellipsis-single(autoresize :max-lines="1") {{ info.content }}
    .tableTop10-mainMiddle
      .tableTop10-time(:class="type=='latestArticlesByPartner' ? 'show--bigScreens' : ''")
        .color--greyBlue90 {{time}}
      .articleNoThumbnail-report()
        i.icon-report2.articleNoThumbnail-icon
        .color--greyBlue90 {{ getNumberString(info.reporterCount) }}
      .articleNoThumbnail-follow()
        //- will show the blue version of the eye icon when isFollowing is true
        i.articleNoThumbnail-icon(:class='following ? "icon-follow-blue" : "icon-follow"' )
        //- will change text color to blue when isFollowing is true
        div(class=following ? "color--blueCornFlower" : "color--greyBlue90") {{ getNumberString(info.followerCount) }}
    .tableTop10-mainBottom
      .tableTop10-info
        .tableTop10-tag.articleTag(:class="getTagClass(info.tag.id, 'tableTop10-tag')") {{info.tag[$store.state.lang]}}
        .tableTop10-verificationText(v-if='showWarning')
          span.articleCard-info-partner 暫時無法顯示
        .tableTop10-verificationText(v-if='info.comments.length > 0')
          span.articleCard-info-partner {{ info.comments[0].partner.name}}
          span(v-if="info.comments.length > 1") ...
            span {{ "(" + info.comments.length + ")" }}
</template>

<script>
import { getTime, getTagClass, getNumberString } from '@/plugins/tool.js'
import VClamp from 'vue-clamp'
export default {
  components: {
    VClamp
  },
  props: {
    info: Object,
    following: Boolean,
    type: String
  },
  data() {
    return {
      getNumberString: getNumberString
    }
  },
  computed: {
    time() {
      // if (this.type == "latestArticles")
      //   return getTime(this.info.createdAt)
      // else
        return getTime(this.info.updatedAt)
    },
    isFollowing() {
      return this.$route.path === '/category' && this.$route.query.type === 'followingArticles'
    },
    showWarning() {
      if (!this.isFollowing) return false
      return this.info.tag.id === 1
    },
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-default-2.png');";
    }
  },
  methods: {
    getTagClass(tagId, className) {
      return getTagClass(tagId, className, this.isFollowing)
    }
  }
}
</script>
